import React, { useRef } from "react";
import RecurrenceModal from "../customer/RecurrenceModal";
import DatePicker from "react-datepicker";
import { createPortal } from "react-dom";
import { ReactComponent as CalendarIcon } from "../../assets/images/icons/DateTimeRec.svg";
import "react-datepicker/dist/react-datepicker.css";
import LabelComponent from "../UniversalComponents/LabelComponent";
import InputComponent from "../UniversalComponents/InputComponent";
const DateTimeRecurence = ({
  innerLabel = "Due Date",
  name,
  showEndDate,
  showTime,
  handleCheckboxChange,
  openPopup,
  isPopupOpen,
  isFormDisabled,
  formData,
  setIsPopupOpen,
  ActivateRecur,
  closePopupRecur,
  taskid,
  setStartDate,
  startDate,
  setEndDate,
  endDate,
  StartTimeElement,
  Fragment,
  EndTimeElement,
  setFormData,
  StartDateChange,
  isMandatory,
  drawerRef,
  isDisableReccurrence,
  minDate = null,
  maxDate = null,
}) => {
  const datePickerStartRef = useRef(null);
  const datePickerEndRef = useRef(null);
  return (
    <>
      <div className="w-full col-span-2">
        <label htmlFor={name} className="basis-5/5 block mb-1 text-lg text-434852 ">
          <div className="flex justify-between gap-1">
            <div className="flex items-center gap-4">
              <LabelComponent
                labelText={innerLabel}
                htmlFor={innerLabel}
                size="small"
                className="font-600"
                isMandatory={innerLabel}
                isFormDisabled={isFormDisabled}
              />

              {/* {(errors?.due_date && startDate && formData?.due_date==='') && <span className="text-red-700">{errors.due_date}</span>} */}
            </div>
          </div>
        </label>

        <div className="flex flex-col gap-1">
          <div className="flex items-center justify-between w-full gap-2">
            <div className="w-1/2 flex gap-x-1">
              <div className={`flex items-center relative w-[97px]`}>
                <DatePicker
                  ref={datePickerStartRef}
                  selected={
                    //check for whether start date is valid date or not
                    startDate instanceof Date && !isNaN(startDate.getTime()) ? startDate : null
                  }
                  onChange={(date) => {
                    StartDateChange(date);
                  }}
                  placeholderText="Start Date"
                  popperContainer={({ children }) => createPortal(children, document.getElementById("portal-root"))}
                  dateFormat="dd-MM-yyyy"
                  className={` rounded border h-[30px] ${isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 px-2`}
                  dropdownMode="select"
                  disabled={formData?.update_single_occurrence || isFormDisabled}
                  minDate={minDate} // disable before 20
                  maxDate={maxDate}
                />
                <div
                  className="absolute right-0 top-0 flex items-center pointer-events-none h-full cursor-pointer"
                  onClick={() => datePickerStartRef.current?.setOpen(true)}
                >
                  <CalendarIcon />
                </div>
              </div>

              <div className=" flex relative w-[70px]">{<StartTimeElement />}</div>
            </div>

            <div className="flex items-center w-[51%] justify-start flex-wrap gap-x-2">
              <div className="flex items-center justify-between gap-1">
                <input
                  type="checkbox"
                  name="showTime"
                  checked={showTime}
                  onChange={handleCheckboxChange}
                  className={`font-medium border-[#D9D9D9] focus:ring-0  rounded-sm focus:ring-offset-0 text-sm appearance-none ${isFormDisabled ? " bg-EDEDED text-868686" : " bg-white text-434852"} checked:bg-primary-90 checked:border-primary`}
                  disabled={isFormDisabled}
                />
                <LabelComponent
                  labelText="All Day"
                  htmlFor="SetTime"
                  size="small"
                  isFormDisabled={isFormDisabled}
                  className="w-full"
                />
              </div>

              <div className="flex items-center justify-between gap-1">
                <input
                  type="checkbox"
                  name="showEndDate"
                  checked={showEndDate}
                  onChange={handleCheckboxChange}
                  className={`font-medium border-[#D9D9D9] focus:ring-0  rounded-sm focus:ring-offset-0 text-sm appearance-none ${isFormDisabled ? " bg-EDEDED text-868686" : " bg-white text-434852"} checked:bg-primary-90 checked:border-primary`}
                  disabled={isFormDisabled}
                />
                <LabelComponent
                  labelText="End Date"
                  htmlFor="SetTime"
                  size="small"
                  isFormDisabled={isFormDisabled}
                  className="inline-block"
                />
              </div>

              {!isDisableReccurrence && (
                <button
                  className={`gap-1 flex items-center hover:text-sm ${isFormDisabled ? "cursor-not-allowed" : "cursor-pointer"}`}
                  disabled={isFormDisabled}
                  onClick={openPopup}
                  type="button"
                >
                  <span className="transform scale-x-[-1]">
                    <i
                      class={`bi bi-arrow-repeat text-lg ${formData?.is_recurrence ? "text-primary" : "text-545F65"} ${isFormDisabled ? "text-545F65" : ""}`}
                    ></i>
                  </span>
                  <label className="text-sm text-primary">Recurring</label>
                </button>
              )}
            </div>
          </div>

          {/* {formData?.after_occur ? (
                          <div className="flex items-center space-x-1">
                            <DatePicker
                              selected={endDate}
                              onChange={(date) => setEndDate(date)}
                              placeholderText={"Select Date Range"}
                              className="bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-800 text-xs block w-full h-7 px-2"
                              dateFormat="dd-MM-yyyy"
                              popperContainer={({ children }) =>
                                createPortal(children, document.getElementById("portal-root"))
                              }
                              disabled={formData?.update_single_occurrence}
                              minDate={startDate}
                            />

                            <div className="relative">{endTimeElement()}</div>
                          </div>
                        ) : endDate ? ( */}

          {showEndDate && (
            <div className="flex flex-col items-start w-full gap-1">
              <label className="text-[0.9rem] text-434852 font-600">End Date</label>
              <div className="flex items-center w-full gap-2">
                <div className={`flex items-center relative w-[97px] cursor-pointer`}>
                  {/* {formData?.category_id === "project" && (
                <div className={`mr-2 text-xs ${isFormDisabled ? " text-868686" : " text-434852"}`}>To</div>
              )} */}
                  <DatePicker
                    ref={datePickerEndRef}
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    placeholderText={"End Date"}
                    // dateFormat={"dd-MM-yyyy"}
                    popperContainer={({ children }) => createPortal(children, document.getElementById("portal-root"))}
                    dateFormat="dd-MM-yyyy"
                    className={` rounded border h-[30px] ${isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 px-2`}
                    disabled={formData?.update_single_occurrence || isFormDisabled}
                    minDate={startDate} // disable before 20
                    maxDate={maxDate}
                    onClick={() => datePickerEndRef.current?.setOpen(true)}
                  />
                  <div
                    className="absolute right-0 top-0 flex items-center pointer-events-none h-full  cursor-pointer"
                    onClick={() => datePickerEndRef.current?.setOpen(true)}
                  >
                    <CalendarIcon className="cursor-pointer" />
                  </div>
                </div>

                <div className={`relative w-[70px]`}>{<EndTimeElement />}</div>
              </div>
            </div>
          )}
        </div>
      </div>
      {isPopupOpen && (
        // <div className="relative w-full min-h-screen h-auto overflow-auto flex justify-center items-start">
        <RecurrenceModal
          open={isPopupOpen}
          setOpen={setIsPopupOpen}
          ActivateRecur={ActivateRecur}
          closePopup={closePopupRecur}
          taskid={taskid}
          className={`text-gray-700 fixed inset-0 transition-all duration-300 ${isPopupOpen ? "blur-sm" : ""}`}
          setStartDate={setStartDate}
          startDate={startDate}
          setEndDate={setEndDate}
          endDate={endDate}
          StartTime={
            <div className="flex flex-col gap-2 w-full">
              {/* date time combo was only being used in addtaskpodmal, thats why removed this from the component itself */}

              {/* <label className="block">
                <input type="checkbox" checked={showTime} onChange={handleCheckboxChange} />
                <span className="ms-1">Set Time</span>
              </label> */}
              <div className="py-2 flex flex-col justify-start w-full">
                <label htmlFor="categories" className="text-434852">
                  <span className="text-[#434852] text-sm font-400">Start Time</span>
                  <span className="text-red-500"> *</span>
                </label>
                <div className="">{<StartTimeElement />}</div>
              </div>
            </div>
          }
          EndTime={
            <Fragment>
              <div className="py-2 flex flex-col justify-start w-full">
                <label htmlFor="categories" className="text-434852">
                  <span className="text-[#434852] text-sm font-400">End Time</span>
                  <span className="text-red-500"> *</span>
                </label>
                <div className="">{<EndTimeElement />}</div>
              </div>
            </Fragment>
          }
          formData={formData}
          setFormData={setFormData}
          drawerRef={drawerRef}
          // parallelDrawer
          subDrawer
        />
        // </div>
      )}
    </>
  );
};

export default DateTimeRecurence;
